import { useState } from "react";
import { Maximize2, X } from "lucide-react";

/* Wraps any product mockup so it can be tapped to expand into a full-screen lightbox. */
export const Zoomable = ({ children, label }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="relative group">
        <div onClick={() => setOpen(true)} className="cursor-zoom-in" data-testid="zoomable-trigger">{children}</div>
        <button onClick={() => setOpen(true)} data-testid="zoom-open" aria-label="Expand"
          className="absolute top-2.5 right-2.5 z-20 h-8 w-8 rounded-lg bg-black/45 backdrop-blur text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <Maximize2 size={14} />
        </button>
      </div>
      {open && (
        <div data-testid="zoom-lightbox" onClick={() => setOpen(false)}
          className="fixed inset-0 z-[100] bg-[#0A0C11]/92 backdrop-blur-sm flex flex-col items-center justify-center p-4 md:p-10 animate-[fadeIn_.2s_ease]">
          <button data-testid="zoom-close" onClick={() => setOpen(false)} aria-label="Close"
            className="absolute top-5 right-5 h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
            <X size={20} />
          </button>
          <div onClick={(e) => e.stopPropagation()} className="w-full max-w-6xl max-h-[86vh] overflow-auto">{children}</div>
          {label && <p className="text-white/70 text-sm mt-4 font-medium">{label}</p>}
        </div>
      )}
    </>
  );
};
